export const AVATAR_SIZE = 32;
export const V4_ACCOUNT_VERSION = 4;
/** Defined in Figma */
export const ACCOUNT_SWITCHER_MENU_WIDTH = 264;
